import reactComponentLoader from 'scripts/react-component-loader'

import FamilyPage from './index'

reactComponentLoader(FamilyPage, '[data-family-page]')
